import { useState } from "react"
import ReactQuill from "react-quill"
import { Col, Row } from "reactstrap"
import DynamicButton from "../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"

const PurchaseProtection = () => {
  const dummyContent = `
  <h1>Purchase Protection</h1>
  <p>
    Pellentesque sollicitudin enim neque, sed semper mi tristique in. Proin scelerisque 
    tortor id egestas laoreet. Morbi iaculis odio mauris, sollicitudin ornare erat 
    consectetur rutrum. Nullam volutpat ut diam vel tincidunt. Fusce ac viverra libero. 
    Quisque vitae lectus erat. Cras iaculis est non ante ullamcorper tincidunt. 
    Pellentesque consectetur pretium quam sit amet lacinia.
  </p>
  
  <p>
    Aliquam erat volutpat. Vivamus augue tortor, lobortis non libero vitae, convallis 
    tristique erat. Donec vel volutpat nunc. Cras a interdum sapien. Nullam dignissim 
    ornare eleifend. In hac habitasse platea dictumst. Curabitur congue molestie nisi, 
    non sollicitudin mauris faucibus vel. Aliquam eget dolor placerat, dapibus dui quis, 
    sodales nulla. Sed luctus quis lacus eget elementum. Curabitur ac magna non arcu 
    varius condimentum accumsan a tortor.
  </p>

  <p>
    Cras a interdum sapien. Nullam dignissim ornare eleifend. In hac habitasse platea 
    dictumst. Curabitur congue molestie nisi, non sollicitudin mauris faucibus vel. 
    Aliquam eget dolor placerat, dapibus dui quis, sodales nulla. Sed luctus quis lacus 
    eget elementum. Curabitur ac magna non arcu varius condimentum accumsan a tortor.
  </p>

  <p>
    Cras a interdum sapien. Nullam dignissim ornare eleifend. In hac habitasse platea 
    dictumst. Curabitur congue molestie nisi, non sollicitudin mauris faucibus vel. 
    Aliquam eget dolor placerat, dapibus dui quis, sodales nulla. Sed luctus quis lacus 
    eget elementum. Curabitur ac magna non arcu varius condimentum accumsan a tortor.
  </p>

  <p>
    Cras a interdum sapien. Nullam dignissim ornare eleifend. In hac habitasse platea 
    dictumst. Curabitur congue molestie nisi, non sollicitudin mauris faucibus vel. 
    Aliquam eget dolor placerat, dapibus dui quis, sodales nulla. Sed luctus quis lacus 
    eget elementum. Curabitur ac magna non arcu varius condimentum accumsan a tortor.
  </p>
`;

  const [value, setValue] = useState(dummyContent || '')

  return (
    <div>
      <div className="fw-medium fs-5 bg-white p-3 shadow my-3">Purchase Protection</div>

      <div className="p-3 shadow bg-white">
        <Row>
          <Col>
            <ReactQuill
              theme="snow"
              value={value}
              onChange={setValue}
              placeholder="Add introduction, highlights or description of your product"
              // className={styles.codeEditor}
            />
          </Col>
          <Col xs='12' lg="auto">
            <DynamicButton theme="blue" className='mt-3 mt-lg-0'>Save</DynamicButton>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default PurchaseProtection
